
import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import InPractisePerf from "@/views/VisuCom/PosterInPractise/InPractisePerf.vue";
import InPractisePerfPhone from "@/views/VisuCom/PosterInPractise/InPractisePerfPhone.vue";
import Pdf from "@/components/Pdf.vue";
import InPractiseEvent from "@/views/VisuCom/PosterInPractise/InPractiseEvent.vue";
import InPractisePPP from "@/views/VisuCom/PosterInPractise/InPractisePPP.vue";
import { BIcon, BIconUpload } from "bootstrap-vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";

@Component({
  components: {
    Header,
    Menu,
    InPractisePerf,
    InPractisePerfPhone,
    Pdf,
    InPractiseEvent,
    InPractisePPP,
    BIcon,
    BIconUpload,
    NextPrevBtn,
    Footer,
  },
})
export default class PosterInPractise extends Vue {
  protected pdfPosterInPractise = [
    {
      PdfLink: "/pdf_poster/ExamplePosterCinema.pdf",
      PdfDownload: "Les participants au concours de la fête du cinéma",
      TxtPdf: "Exemples concours d’affiches – La fête du cinéma",
    },

    {
      PdfLink: "/pdf_poster/SpecificationsPosterCinema.pdf",
      PdfDownload: "Cahier des charges de l’affiche de la fête du cinéma",
      TxtPdf: "Cahier des charges de l’affiche de la fête du cinéma",
    },
  ];
  protected nxtprevPosterInPractise = {
    BoolPrev: true,
    BoolNext: true,
    PrevImage: "/thumbnail4.png",
    NextImage: "/thumbnail7.png",
    PrevLink: "/Affiche/Astuces",
    NextLink: "/Affiche/Trouver_lInspiration",
  };
}
